import styles from './static-map-bullet.module.scss';
import cn from 'classnames';
import React from 'react';
import { MapBulletIcon } from '@y2/mango/components/icons';

type Props = {
  className?: string;
  text: string;
};

export const StaticMapBullet = ({ className, text }: Props) => {
  return (
    <div className={cn(styles.staticMapBulletBox, className)}>
      <span className={styles.bulletTitle}>{text}</span>
      <MapBulletIcon className={styles.bullet} />
    </div>
  );
};
